import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

interface Slide {
  image: string;
  title: string;
  description: string;
}

interface HeroSliderProps {
  currentSlide: number;
  direction: number;
  slides: Slide[];
  variants: any;
  onDragEnd: (e: any, info: any) => void;
  setPage: (value: [number, number]) => void;
}

const HeroSlider: React.FC<HeroSliderProps> = ({
  currentSlide,
  direction,
  slides,
  variants,
  onDragEnd,
  setPage
}) => {
  // Preload images
  useEffect(() => {
    slides.forEach(slide => {
      const img = new Image();
      img.src = slide.image;
    });
  }, [slides]);

  // Calculate previous slide index
  const prevSlide = (currentSlide - 1 + slides.length) % slides.length;
  const nextSlide = (currentSlide + 1) % slides.length;

  return (
    <>
      {/* Previous slide as background */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${slides[prevSlide].image})` }}
      />
      
      {/* Current slide */}
      <motion.div
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{
          x: { type: "spring", stiffness: 50, damping: 20 },
          opacity: { duration: 0.8 }
        }}
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={1}
        onDragEnd={onDragEnd}
        className="absolute inset-0"
      >
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: `url(${slides[currentSlide].image})`,
            transform: currentSlide === 2 ? 'scale(1.2)' : 'none',
            transformOrigin: 'center'
          }}
        />
      </motion.div>

      {/* Next slide preloaded */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-0"
        style={{ backgroundImage: `url(${slides[nextSlide].image})` }}
      />
    </>
  );
};

export default HeroSlider;